import { createContext, useContext, useEffect, useState } from "react";
import {
  onAuthStateChanged,
  signOut,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import {auth} from "../firebase";

const userAuthContext = createContext({
  googleSignIn: () => Promise,
  logOut: () => Promise,
});

export function UserAuthContextProvider({ children }) {
  const [user, setUser] = useState({});
  // validate user tocken

  function logOut() {
    return signOut(auth);
  }
  function googleSignIn() {
    const googleAuthProvider = new GoogleAuthProvider();
    return signInWithPopup(auth, googleAuthProvider);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentuser) => {
      setUser(currentuser ? currentuser : null); 
    })

    return () => {
      unsubscribe();
    }
  }, []);

  useEffect(() => {
    // console.log('The user is', user)
  }, [user])

  // autologout using user token expire
  // useEffect(() => {
  //   if (user) {
  //     const unsubscribe = auth.onAuthStateChanged((currentuser) => { 
  //       if (currentuser) {
  //         const { exp } = currentuser.getIdTokenResult().then((token) => {
  //           const expires = token.claims.exp;
  //           const now = Date.now() / 10000;
  //           console.log(now);
  //           console.log(expires);
  //           if (expires < now) {
  //             console.log('User token expired');
  //             logOut();
  //           }
  //         });
  //       }
  //     });
  //     return () => {
  //       unsubscribe();
  //     }
  //   }
  // }, [user]);

  // auto logout when user close the browser
  // useEffect(() => {
  //   const logout = () => {
  //     logOut();
  //   }
  //   window.addEventListener('beforeunload', logout);
  //   return () => {
  //     window.removeEventListener('beforeunload', logout);
  //   }
  // }, []);
  

  return (
    <userAuthContext.Provider
      value={{ user, logOut, googleSignIn }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}